import React, { createContext, useState } from 'react';

interface CookieBotContextValues {
  setSuppressCookieBot: (suppress: boolean) => void;
  suppressCookieBot: boolean;
}

export const CookieBotContext = createContext<CookieBotContextValues>({
  setSuppressCookieBot: () => {},
  suppressCookieBot: false,
});

const CookieBotProvider = ({ children }: { children: React.ReactNode }) => {
  const [suppressCookieBot, setSuppressCookieBot] = useState<boolean>(false);

  const contextValue = {
    setSuppressCookieBot,
    suppressCookieBot,
  };

  return (
    <CookieBotContext.Provider value={contextValue}>
      {children}
    </CookieBotContext.Provider>
  );
};

export default CookieBotProvider;
